import api from 'api'
import { Positions } from 'pages/Positions/Positions/types'

export type PositionStatusFilter = 'approved' | 'unapproved' | 'all'
export type PrescreenStatusFilter = 'prescreened' | 'not-prescreened' | 'all'

type GetAllPositionsRequest = {
  page: number
  pageSize: number
  positionIds?: number[]
  status?: PositionStatusFilter
  prescreenStatus?: PrescreenStatusFilter
  companyIds?: number[]
  companyGroupIds?: number[]
}

type GetAllPositionsResponse = {
  items: Positions
  totalRows: number
}

export const getAllPositions = async (
  request: GetAllPositionsRequest
): Promise<GetAllPositionsResponse> => {
  const response = await api.get<GetAllPositionsResponse>('/admin/positions', {
    params: {
      page: request.page,
      pageSize: request.pageSize,
      position_ids: request.positionIds,
      // The API treats an absent status as "all", so omit it in that case.
      status: request.status === 'all' ? undefined : request.status,
      // The API expects a boolean (or omitted for "all"), not the enum.
      prescreened:
        request.prescreenStatus === undefined ||
        request.prescreenStatus === 'all'
          ? undefined
          : request.prescreenStatus === 'prescreened',
      company_ids: request.companyIds,
      company_group_ids: request.companyGroupIds,
    },
  })
  return response.data
}
